import React, { useState, useEffect } from "react";
import { Button, Field, Groupper, Input, Message, Dropdown, useFrontier } from 'react-frontier2';
import { useNavigate } from "react-router-dom";
import { CityVenues, Venue } from "@arema/components/Classes";
import { EventSectionProps } from '../../AdminClasses';
import { getNowLocal } from "@arema/components/Util";
import API from "../../API";
import Validator from "@arema/components/Validator";

var EventContainer = (props: EventSectionProps)=>{
	var { Toast } = useFrontier();
	var navigate = useNavigate();
	var [cities, setCities] = useState<CityVenues[]>(null);
	var [selectedCity, setSelectedCity] = useState<string>(null);
	var [cityVenuesList, setCityVenuesList] = useState<{ city: string, venues: Venue[] }[]>([]);
	var [cityVenues, setCityVenues] = useState<Venue[]>(null);
	var [cityError, setCityError] = useState<string>(null);
	var [selectedVenue, setSelectedVenue] = useState<number>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	var [date, setDate] = useState<Date>(null);

	useEffect(()=>{
		if(!cities){
			API.getEventsQL(['cities']).then(res=>{
				if(res.error){
					Toast.error(res.message);
					return navigate(-1);
				}
				setCities((res.data.cities as CityVenues[]));
			}).catch(err=>{
				Toast.error('Hubo un error inesperado cargando la información de recintos. (LCL-1)');
				return navigate(-1);
			});
		}
	}, []);

	var onCitySelected = (v: string)=>{
		setSelectedCity(v);
		setSelectedVenue(null);
		var cv = cityVenuesList.find(a=>a.city==v)
		if(cv){
			return setCityVenues(cv.venues);
		}
		setCityVenues(null);
		API.getCityVenues(v).then(res=>{
			if(res.error) return setCityError(res.message);
			var cvn = [...cityVenuesList];
			cvn.push({ city: v, venues: res.data });
			setCityVenuesList(cvn);
			setCityVenues(res.data);
		}).catch(err=>{
			setCityError('Hubo un error cargnado los recintos. (LCL-1)');
		})
	}

	var submit = (setLoading: (b: boolean)=>void)=>{
		var { valid, prompts, form } = Validator({ venue_id: selectedVenue, date }, {
			venue_id: [
				{ rule: 'number', prompt: 'Favor de seleccionar el recinto' }
			],
			date: [
				{ rule: 'empty', prompt: 'Favor de seleccionar la fecha del calendario' },
			],
		});

		setErrorPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.createDate(props.event.event_id, Math.floor(date.getTime()/1000), form.venue_id).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			if(res.data.date_id) navigate(`/events/${props.event.event_id}/dates/${res.data.date_id}`, {
				replace: true
			});
			else setErrorPrompts(['Hubo un error inesperado creando el calendario (LCL-3)']);
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado creando el calendario (LCL-2)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	return <Groupper title="Crear calendario" style={{ maxWidth: 600, margin: 'auto' }} actions={(
		<Button text="Crear calendario" color="black" onClick={submit} />
	)}>
		<Input label="Fecha" placeholder="Fecha del calendario" inputStyle={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold' }} calendar={{
			date: date,
			mode: 'datetime',
			onSelected: setDate
		}} />
		<Dropdown label="Ciudad" search loading={!cities} disabled={!cities} value={selectedCity} onValueChange={onCitySelected} items={cities ? cities.map(a=>({
			value: a.city,
			text: a.city,
			meta: `${a.venues} recinto${a.venues==1 ? '' : 's'}`,
		})) : []} />
		{cityError ? (
			<Message text={cityError} type="error" />
		) : (selectedCity) ? (
			<Dropdown search label="Recinto" placeholder="Selecciona el recinto" onValueChange={setSelectedVenue} value={selectedVenue} loading={!cityVenues} items={cityVenues ? cityVenues.map(a=>({
				value: a.venue_id,
				text: a.venue_name,
				meta: `ID: ${a.venue_id}`
			})) : []} />
		) : null}
		<Message list={errorPrompts} type="error" />
	</Groupper>
}

export default EventContainer;